import { Func } from '../types';

export function over<A extends unknown[], R1, R2, R3, R4, R5, R6>(
    fns: [Func<A, R1>, Func<A, R2>, Func<A, R3>, Func<A, R4>, Func<A, R5>, Func<A, R6>]
): (...args: A) => [R1, R2, R3, R4, R5, R6];

export function over<A extends unknown[], R1, R2, R3, R4, R5>(
    fns: [Func<A, R1>, Func<A, R2>, Func<A, R3>, Func<A, R4>, Func<A, R5>]
): (...args: A) => [R1, R2, R3, R4, R5];

export function over<A extends unknown[], R1, R2, R3, R4>(
    fns: [Func<A, R1>, Func<A, R2>, Func<A, R3>, Func<A, R4>]
): (...args: A) => [R1, R2, R3, R4];
export function over<A extends unknown[], R1, R2, R3>(
    fns: [Func<A, R1>, Func<A, R2>, Func<A, R3>]
): (...args: A) => [R1, R2, R3];
export function over<A extends unknown[], R1, R2>(fns: [Func<A, R1>, Func<A, R2>]): (...args: A) => [R1, R2];
export function over(fns: Func[]): (...args: unknown[]) => unknown[];

export function over(fns: Func[]) {
    return (...args: unknown[]) => fns.map((f) => f(...args));
}
